<template>
  <Layout>
    <div class="mc-unsubscribe__form">
      <div class="mc-unsubscribe__form-wrapper mc-unsubscribe__form-wrapper--digest">
        <div class="mc-upload">
          <div class="mc-upload-result mc-upload-result--success">
            <figure>
              <img src="@/assets/images/success-icon.png" alt />
            </figure>
            <h4 class="mc-unsubscribe__label">
              {{ title }}
            </h4>
            <p>
              {{ subTitle }}
            </p>
            <hr class="dashed-line" />
            <h5>
              {{ $t('unsubscribe.digest.result.subscribe') }}
            </h5>
            <p>
              {{ $t('unsubscribe.digest.result.subscribeDesc') }}
              <a @click="redirectTo">{{ $t('unsubscribe.digest.result.clickHere') }}</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<script>
import Layout from '@/router/layouts/auth'
import appConfig from '@/app.config'
export default {
  page: {
    title: 'Unsubscribe',
    meta: [
      {
        name: 'description',
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
  },
  data() {
    return {
      redirect: '',
    }
  },
  computed: {
    type() {
      const mappingType = {
        daily: this.$t('global.time.daily'),
        weekly: this.$t('global.time.weekly'),
        monthly: this.$t('dashboard.text.costPeriod.last12Months'),
      }
      return mappingType[this.$route.params.type]
    },
    title() {
      return this.$t('unsubscribe.digest.result.title', { type: this.type })
    },
    subTitle() {
      return this.$t('unsubscribe.digest.result.subTitle')
    },
  },
  methods: {
    redirectTo() {
      const redirectUrl = window.location.protocol + '//' + window.location.host + '/scheduler'
      window.location.replace(redirectUrl)
    },
  },
}
</script>
<style lang="scss" scoped>
@import '../style.scss';
</style>
